// promoción al comprar producto de cierta marca
import { useState, useEffect } from 'react';

import { basicMsg } from '../../../../actions/swal_msg';
import { savePromoToBD } from '../../../../actions/admin/promotion';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Grid, TextField, Stack, Button, ToggleButtonGroup, ToggleButton,
    List, ListItemButton, ListItemText, ListItemAvatar, Avatar
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { regex_dec, regex_num, regex_two_dec } from '../../../../constants/regex';

const PromoSeven = ({
    today, promotion,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion,
    brands
}) => {
    const { promo, start_date, end_date } = promotion;

    const [data, setData] = useState({
        label: 'Descuento (%)',
        maxLength: 5,
        helperText: '% de descuento',
        type: 'Descuento % en marca'
    });
    const { label, maxLength, helperText, type } = data;
    
    // valor de descuento
    const [discount, setDiscount] = useState('');
    // tipo de descuento
    const [alignment, setAlignment] = useState('percentage');
    // marca
    const [selectedBrand, setSelectedBrand] = useState('');
    
    const setTextData = () => {
        if (alignment === 'fixed')
            setData(e => ({
                ...e, label: 'Descuento ($)',
                maxLength: 10,
                helperText: `$${discount} de descuento (después de IVA)`,
                type: `$${discount} de descuento en ${
                    selectedBrand ? `marca ${selectedBrand}`
                    : 'marca'
                }`
            }));
        else if (alignment === 'percentage')
            setData(e => ({
                ...e, label: 'Descuento (%)',
                maxLength: 5,
                helperText: `${discount}% de descuento`,
                type: `${discount}% de descuento en ${
                    selectedBrand ? `marca ${selectedBrand}`
                    : 'marca'
                }`
            }));
        else
            setData(e => ({
                ...e, label: 'X',
                maxLength: 1,
                helperText: `Descuento incorrecto`,
                type: 'No se reconoce tipo de descuento en marca'
            }));
    };

    useEffect(() => {
        if (alignment === 'fixed') {
            if (discount !== '' && !regex_two_dec.test(discount))
                setDiscount('');
            else
                setTextData();
        } else if (alignment === 'percentage') {
            if (discount !== '' && !regex_num.test(discount))
                setDiscount('');
            else
                setTextData();
        } else
            setDiscount('');
    }, [alignment]);

    useEffect(() => {
        setTextData();
    }, [discount, selectedBrand]);
    
    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'discount') {
            if (alignment === 'fixed') {
                if (value === '' || regex_dec.test(value))
                    setDiscount(value);
            } else {
                if (value === '' || regex_num.test(value))
                    setDiscount(value);
            }
        }
    };

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null)
            setAlignment(newAlignment);
    };

    const handleListItemClick = (event, index) => {
        setSelectedBrand(index);
    };
    
    // productos A seleccionado, se introdujo descuento
    const validation = () => {
        // valor de descuento a numérico
        const num = Number(discount);
        if (selectedBrand === '')
            basicMsg('Seleccione marca de productos');
        else if (discount === '')
            basicMsg(alignment === 'fixed' ?
                'Seleccione la cantidad de descuento' :
                'Seleccione el porcentaje de descuento'
            );
        else if (alignment === 'percentage' && (num < 1 || num > 100))
            basicMsg('Porcentaje de descuento es incorrecto');
        else if (alignment === 'fixed')
            basicMsg('No se permiten descuentos fijos');
        else return true;

        return false;
    };

    // verificar si existen promociones con el producto
    const checkPromos = async() => {
        if (validation()) {
            const { status, html } = getProductPromotions(
                promo, activePromotion, otherPromotion, {}, selectedBrand
            );
            if (status)
                basicMsg(html);
            else savePromo();
        }
    };

    // guardar promoción del producto
    const savePromo = async () => {
        // Number(discount)
        const Model = {
            ...promotion,
            discount,
            discount_type: alignment,
            brand: selectedBrand
        };
        const req = await savePromoToBD(Model, 'save-promo-six');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setDiscount('');
            setSelectedBrand('');
        }
    };

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        { `Promoción: ${type}` }
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <ToggleButtonGroup
                            sx={{ mt: 2 }}
                            color="primary"
                            value={ alignment }
                            exclusive
                            onChange={ handleAlignment }
                            aria-label="discount"
                            >
                            <ToggleButton value="type" disabled>Tipo descuento</ToggleButton>
                            <ToggleButton value="percentage">%</ToggleButton>
                            <ToggleButton value="fixed" disabled>$</ToggleButton>
                        </ToggleButtonGroup>

                        <TextField fullWidth
                            sx={{ mt: 1 }}
                            name="discount"
                            label={ label }
                            variant="standard"
                            inputProps={{ maxLength }}
                            helperText={ helperText }
                            value={ discount }
                            onChange={ handleInputChange }
                        />

                        {
                            selectedBrand !== '' &&
                                <Button sx={{ mt: 1 }}
                                    variant="contained"
                                    onClick={ checkPromos }>
                                    Guardar promoción
                                </Button>
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" gutterBottom>
                            Marcas disponibles
                        </Typography>
                        <List
                            sx={{
                                width: '100%',
                                maxWidth: 360,
                                bgcolor: 'background.paper',
                                position: 'relative',
                                overflow: 'auto',
                                maxHeight: 300,
                                '& ul': { padding: 0 }
                            }}>
                            {
                                brands.map(({ brand, url, image_id }) =>
                                    <ListItemButton key={url}
                                        selected={ selectedBrand === brand }
                                        onClick={
                                            (event) => handleListItemClick(event, brand)
                                        }>
                                        <ListItemAvatar>
                                            <Avatar alt={ url } src={ image_id } />
                                        </ListItemAvatar>
                                        <ListItemText primary={ brand } />
                                    </ListItemButton>
                                )
                            }
                        </List>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PromoSeven;